<div
    (mouseenter)="expand = true" 
    (mouseleave)="expand = false" 
    [ngClass]="{'animated-in': expand, 'animated-out': !expand}"
    class="trustpilot-container"     
    (click)="redirect($event)">
    <div class="data-container">
        <div class="rate-icon-container">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                <style type="text/css">
                    .st-trustpilot{fill:#00B67A;}
                </style>
                <path class="st-trustpilot" d="M13.2,12.8l-0.4-1.2l-2.8,2L13.2,12.8z M17.9,0H2.1C1,0,0,1,0,2.1v15.7C0,19,1,20,2.1,20h15.7  c1.2,0,2.1-1,2.1-2.1V2.1C20,1,19,0,17.9,0z M14.5,16.9L10,13.6l-4.5,3.3l1.7-5.3L2.8,8.4l5.5,0L10,3.1l1.7,5.3h5.5l-4.5,3.3  L14.5,16.9z"/>
            </svg>
            <span class="rate">4.9</span>
        </div>
        <span class="reviews-count" [ngClass]="{'shown': expand, 'hidden': !expand}"> | {{ 'TRUSTPILOT_REVIEWS_COUNT' | translate }}</span>
    </div>
</div>